class PvhHeadersController {
  set items (items) {
    localStorage.setItem('pvhHeaders', JSON.stringify(items))
    this.headers = items
  }

  get items () {
    return this.headers
  }

  constructor () {
    this.headers = JSON.parse(localStorage.getItem('pvhHeaders')) ?? [
      {
        title: 'Статус',
        isSortable: true,
        dispatchName: 'getPvhSort',
        shown: true,
        sortName: 'pvc_order_status.name'
      },
      {
        title: 'КП',
        isSortable: true,
        dispatchName: 'getPvhSort',
        shown: true,
        sortName: 'code'
      },
      {
        title: 'Клиент',
        isSortable: true,
        dispatchName: 'getPvhSort',
        shown: true,
        sortName: 'pvc_client.surname|name'
      },
      {
        title: 'Адрес',
        shown: true,
        isSortable: false
      },
      {
        title: 'Телефон',
        shown: true,
        isSortable: false
      },
      {
        title: 'Сумма',
        isSortable: true,
        dispatchName: 'getPvhSort',
        shown: true,
        sortName: 'value'
      },
      {
        title: 'Замерщик',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'gaugers.surname'
      },
      {
        title: 'Установщик',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'installers.surname'
      },
      {
        title: 'Способ доставки',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'pvc_delivery.name'
      },
      {
        title: 'Готовность в цеху',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'availability_date'
      },
      {
        title: 'Тип заказ',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'pvc_order_type.name'
      },
      {
        title: 'Объект/Контрагент',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'contractor'
      },
      {
        title: 'Дата установки',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'installation_date'
      },
      {
        title: 'Дата замера',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'availability_date'
      },
      {
        title: 'Квадратные метры',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'square_meters'
      },
      {
        title: 'Количество/шт.',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'count'
      },
      {
        title: 'Код RAL',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'code_ral'
      },
      {
        title: 'Толщина материалов',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'depth'
      },
      {
        title: 'Создано',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'created_at'
      },
      {
        title: 'Изменено',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'updated_at'
      },
      {
        title: 'Создатель',
        isSortable: true,
        dispatchName: 'getPvhSort',
        sortName: 'creator'
      }
    ]
  }

  addItem (item) {
    this.items = [...this.headers, item]
  }

  setItems (items) {
    this.items = items
  }

  clearItems () {
    this.items = []
  }
}

export default new PvhHeadersController()
